import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { checkAccess, INTERNAL_USER_ROLES } from '@/src/lib/authorization/authorization';
import { RootState } from '@/src/reducers/types';

import { useGetDrafts } from '../../api/getDrafts';
import { useQuickbookTransactions } from '../../api/getTreatments';

const TreatmentsTabHeader = ({ documentId, inboxDocumentId }) => {
  const loggedUser = useSelector((store: RootState) => store.loggedUser);
  const isInternalUser = useMemo(
    () => checkAccess({ user: loggedUser.data, allowedRoles: INTERNAL_USER_ROLES }),
    [loggedUser]
  );

  const transactionsQuery = useQuickbookTransactions({
    inboxDocumentId,
  });
  const draftsQuery = useGetDrafts({
    documentId,
    config: {
      enabled: isInternalUser,
    },
  });

  const totalCount =
    (transactionsQuery.data?.transactions.length ?? 0) + (draftsQuery.data?.length ?? 0) || 0;
  return <React.Fragment>Treatment {totalCount > 0 && `(${totalCount})`}</React.Fragment>;
};
export default TreatmentsTabHeader;
